import apiFetch from '../apiFetch'

export default function (token, sourceChannelId, body) {
  return apiFetch({ endPoint: `SourceChannel/${sourceChannelId}`, method: 'PUT', body: body, token: token })
}
